import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import {
  FADE_IN_CONTENT_BY_HEIGHT_OPACITY,
  FADE_IN_CONTENT_BY_OPACITY_ONE_WAY
} from '@app/core/constants/animations.constant';

import { PRODUCT_SUBCATEGORIES_ITEM_COUNT } from '../../constants';
import { ProductSubcategoriesActions } from '../../store';
import { DpHomeProductSubcategoriesComponent } from '../home-product-subcategories/home-product-subcategories.component';

@Component({
    selector: 'dp-product-list-subcategories',
    templateUrl: './product-list-subcategories.component.html',
    styleUrl: './product-list-subcategories.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [FADE_IN_CONTENT_BY_HEIGHT_OPACITY, FADE_IN_CONTENT_BY_OPACITY_ONE_WAY],
    standalone: false
})
export class DpProductListSubcategoriesComponent extends DpHomeProductSubcategoriesComponent {
  hasShowDescription = signal<boolean>(false);
  readonly #activeRoute = inject(ActivatedRoute);
  readonly #breakpointService = inject(BreakpointService);
  readonly #destroyRef = inject(DestroyRef);

  onToggleDescriptionVisibility(): void {
    this.hasShowDescription.update((value) => !value);
  }

  protected loadData(productCatalog: string): void {
    this.#activeRoute.params
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        map((params) => params?.categoryCode),
        filter((categoryCode) => !!categoryCode && !String(categoryCode).includes('psf'))
      )
      .subscribe((categoryCode) => {
        this.hasShowDescription.set(false);
        this.store.dispatch(ProductSubcategoriesActions.loadProductSubcategories({ productCatalog, categoryCode }));
      });
  }

  protected initVisibleItems(): void {
    this.#breakpointService
      .isDown(BREAKPOINT.sm)
      .pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged())
      .subscribe((res) => {
        const visibleItemsCount = res
          ? PRODUCT_SUBCATEGORIES_ITEM_COUNT.MOBILE
          : PRODUCT_SUBCATEGORIES_ITEM_COUNT.DESKTOP;
        this.store.dispatch(ProductSubcategoriesActions.setVisibleItemsCount({ visibleItemsCount }));
      });
  }
}
